import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from './api-endpoints.service';
import { ToastService } from './toast.service';
import { inject } from '@angular/core';
// import { IApiResponse } from '../../../../shared/src/import-export';
import { tap } from 'rxjs';
import { Router } from '@angular/router';
import { IApiResponse } from '../library/interfaces';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const token = localStorage.getItem('token') ?? '';

  const authService = inject(AuthService);
  const toastService = inject(ToastService);
  const state = inject(Router)

  authService.crudLoader.set(true)

  request = request.clone({
    headers: request.headers.append('Authorization', token ? `bearer ${token}` : ''),
  });

  const showMessage = (res: IApiResponse<any>) => {
    if (res.error) {
      toastService.showErrorToast(res.message);
    } else {
      toastService.showSuccessToast(res.message);
    }
  }

  return next(request).pipe(tap(async event => {
    if (event.type === HttpEventType.Response) {
      authService.crudLoader.set(false);
      // console.log(request.url,event.status,'Response:', event.headers);
      if (event.headers.get('Content-Type')?.includes('application/json')) {
        if (request.responseType == 'blob') {
          const res = event.body as Blob;
          const result = JSON.parse(await res.text()) as IApiResponse<any>
          showMessage(result)
        } else {
          const res = event.body as IApiResponse<any>;
          showMessage(res)
        }
      }
      if (event.headers.get('X-Auth')?.includes('unauthorized')) {
        console.log("trying logout")
        // router.navigateByUrl('/', { replaceUrl: true });
        const url = state.url.substring(1,)
        console.log('state url', url)
        if (url.match(/^@[\w]+$/gm)) {
          console.log('state url', url)
          authService.setRedirectUrl(url);
          console.log('getRedirectUrl', authService.getRedirectUrl())
        } else {
          authService.logout()
        }
      }
      if (event.headers.get('X-File-Name')) {

        const a = document.createElement('a');
        const blob = new Blob([event.body as BlobPart],
          { type: event.headers.get('Content-Type') }
        );
        const url = window.URL.createObjectURL(blob);

        a.href = url;
        a.target = '_blank'
        a.download = event.headers.get('X-File-Name') ?? 'file.unknown';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    }
  }));
};
